
import { webContentTab } from '../data/data';
import { BiEdit } from "react-icons/bi";
import { FiFileText } from "react-icons/fi";
import { Link } from 'react-router-dom';
import { PageContainer, PageHeader } from '../components/admin/AdminUI';

const WebContent = ({permission}) => {
  return (
    <PageContainer className='webContentPage'>
      <PageHeader eyebrow="Content management" title="Web content" description="Choose a public page to review and edit its content." />
      <div className="cmsPageGrid">
        {webContentTab.map((item) => (
          <Link className="cmsPageCard" to={item.link} key={item.link}>
            <span className="cmsPageCard__icon"><FiFileText aria-hidden="true" /></span>
            <span className="cmsPageCard__content"><strong>{item.label}</strong><small>Manage page content, media, and translations</small></span>
            <span className="cmsPageCard__edit"><BiEdit aria-hidden="true" /><span>Edit</span></span>
          </Link>
        ))}
      </div>
    </PageContainer>
  )
}

export default WebContent
